import type { KeywordActiveList } from './keyword'

// POST /google/ads-account/{id}/keyword
export interface AddAccountKeywordDTO {
  keywordIDs: string[]
  brandID: string
}

// GET /google/ads-account/{id}/keyword
export interface AdsAccountKeywordWithDetailsDTO {
  adsAccountID: string
  keywordID: string
  details: KeywordActiveList
}

// GET /google/seo-account/{id}/keyword
export interface SeoAccountKeywordWithDetailsDTO {
  seoAccountID: string
  keywordID: string
  details: KeywordActiveList
}

export interface GoogleLinkedKeyword {
  keywordID: string
  details?: AdsAccountKeywordWithDetailsDTO['details']
  isAds: boolean
  isSeo: boolean
}

/**
 * Merges linked-keyword rows fetched across Google Ads and Google Search Console accounts into
 * a single map keyed by keyword ID, keeping both flags so a keyword linked via either counts as
 * "linked to Google" while still knowing which service(s) it's linked through.
 */
export function mergeGoogleLinkedKeywords(
  adsRows: AdsAccountKeywordWithDetailsDTO[] | undefined,
  seoRows: SeoAccountKeywordWithDetailsDTO[] | undefined,
): Map<string, GoogleLinkedKeyword> {
  const map = new Map<string, GoogleLinkedKeyword>()

  adsRows?.forEach((k) => {
    map.set(k.keywordID, { keywordID: k.keywordID, details: k.details, isAds: true, isSeo: false })
  })

  seoRows?.forEach((k) => {
    const existing = map.get(k.keywordID)
    if (existing) {
      existing.isSeo = true
    } else {
      map.set(k.keywordID, {
        keywordID: k.keywordID,
        details: k.details,
        isAds: false,
        isSeo: true,
      })
    }
  })

  return map
}
